import Router from 'vue-router'
import Layout from '../views/layout/Layout'
import Vue from 'vue'

Vue.use(Router)

export const routerConfig = {
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      component: Layout
    },
    {
      path: '/dashboard',
      component: Layout,
      name: 'AsyncMQ',
      redirect: window.__POWERED_BY_QIANKUN__ ? '/dashboard/request' : '/dashboard/topic',
      meta: { title: 'Async Platform' },
      children: [
        {
          path: 'index',
          name: 'Dashboard',
          component: () => import(/* webpackChunkName: "dashboard-index" */ '../views/dashboard/index.vue'),
          meta: { title: 'Dashboard' }
        },
        {
          path: 'user',
          name: 'User',
          component: () => import(/* webpackChunkName: "dashboard-user" */'../views/user/index.vue'),
          meta: { title: 'User' }
        },
        {
          path: 'user/:userName',
          name: 'ProducerGroup',
          component: () => import(/* webpackChunkName: "producer-group" */'../views/user/group.vue'),
          meta: { title: 'Producer Group' }
        },
        {
          path: 'user/multiSecret/:appName/:appId',
          name: 'MultiSecret',
          component: () => import(/* webpackChunkName: "producer-multi-secret" */'../views/user/multiSecret.vue'),
          meta: { title: 'Multi Secret' }
        },
        {
          path: 'topic',
          name: 'Topic',
          component: () => import(/* webpackChunkName: "topic" */'../views/topic/index.vue'),
          meta: { title: 'Topic' }
        },
        {
          path: 'migratingTopic',
          name: 'MigratingTopic',
          component: () => import(/* webpackChunkName: "migrating-topic" */'../views/topic/migratingTopics.vue'),
          meta: { title: 'MigratingTopic' }
        },
        {
          path: 'collection',
          name: 'Collection',
          component: () => import(/* webpackChunkName: "collection" */'../views/collection/index.vue'),
          meta: { title: 'Collection' }
        },
        {
          path: 'request',
          name: 'Request',
          component: () => import(/* webpackChunkName: "request-modern" */'../views/requestModern/index.vue'),
          meta: { title: 'Request', toggle: 'classicRequest' }
        },
        {
          path: 'classicRequest',
          name: 'ClassicRequest',
          component: () => import(/* webpackChunkName: "request-classic" */'../views/requestClassic/index.vue'),
          meta: { title: 'ClassicRequest', toggle: 'request' }
        },
        {
          path: 'task',
          name: 'Task',
          component: () => import(/* webpackChunkName: "task-modern" */'../views/task/task.vue'),
          meta: {
            title: 'Task',
            label: 'Task',
            toggle: 'classicTask'
          }
        },
        {
          path: 'TaskDetail',
          name: 'TaskDetail',
          component: () => import(/* webpackChunkName: "task-detail" */'../views/task/taskDetail.vue'),
          meta: {
            title: 'TaskDetail',
            useIndependentInstance: true
          }
        },
        {
          path: 'classicTask',
          name: 'ClassicTask',
          component: () => import(/* webpackChunkName: "task-classic" */'../views/task/index.vue'),
          meta: {
            title: 'Task(Classic)',
            label: 'Task(Classic)',
            toggle: 'task'
          }
        },
        {
          path: 'longTask',
          name: 'LongTask',
          component: () => import(/* webpackChunkName: "long-task" */'../views/task/longTask.vue'),
          meta: { title: 'Long Task' }
        },
        {
          path: 'trigger',
          name: 'BatchTrigger',
          component: () => import(/* webpackChunkName: "batch-trigger" */'../views/trigger/index.vue'),
          meta: { title: 'Trigger' }
        },
        {
          path: 'trigger/:triggerId',
          name: 'Triggers',
          component: () => import(/* webpackChunkName: "trigger" */'../views/trigger/task.vue'),
          meta: { title: 'TriggerTasks', keepAlive: false }
        },
        {
          path: 'job',
          name: 'Job',
          component: () => import(/* webpackChunkName: "job" */'../views/job/index.vue'),
          meta: { title: 'Job' }
        },
        {
          path: 'datacenter',
          name: 'DataCenter',
          component: () => import(/* webpackChunkName: "datacenter" */'../views/datacenter/index.vue'),
          meta: { title: 'DataCenter' }
        },
        {
          path: 'datacenterrouter',
          name: 'DataCenterRouter',
          component: () => import(/* webpackChunkName: "datacenterrouter" */'../views/datacenter/router.vue'),
          meta: { title: 'DataCenterRouter' }
        },
        {
          path: 'group',
          name: 'Group',
          component: () => import(/* webpackChunkName: "group" */'../views/group/index.vue'),
          meta: { title: 'Group' }
        },
        {
          path: 'nonAuthConfig',
          name: 'NonAuthConfig',
          component: () => import(/* webpackChunkName: "nonAuthConfig" */'../views/settings/nonAuthConfig/index.vue'),
          meta: { title: 'Public Config' }
        },
        {
          path: 'channel',
          name: 'Channel',
          component: () => import(/* webpackChunkName: "channel" */'../views/channel/index.vue'),
          meta: { title: 'Channel' }
        },
        {
          path: 'sentinel',
          name: 'Sentinel',
          component: () => import(/* webpackChunkName: "sentinel" */'../views/channel/sentinel.vue'),
          meta: { title: 'Sentinel' }
        },
        {
          path: 'channel/describe/:id',
          name: 'Describe',
          component: () => import(/* webpackChunkName: "describe" */'../views/channel/describe.vue'),
          meta: { title: 'Describe' },
          children: [
            {
              path: 'topic',
              name: 'ChannelTopicDescribe',
              component: () => import(/* webpackChunkName: "channel-topic-describe" */'../views/channel/topicDescribe.vue'),
              meta: { title: 'Topic Describe' }
            },
            {
              path: 'group',
              name: 'ChannelGroupDescribe',
              component: () => import(/* webpackChunkName: "channel-group-describe" */'../views/channel/groupDescribe.vue'),
              meta: { title: 'Group Describe' }
            }
          ]
        },
        {
          path: 'status',
          name: 'Status',
          component: () => import(/* webpackChunkName: "status" */'../views/status/index.vue'),
          meta: { title: 'Status' }
        },
        {
          path: 'zk',
          name: 'ZK',
          component: () => import(/* webpackChunkName: "zk" */'../views/zk/index.vue'),
          meta: { title: 'ZK' }
        },
        {
          path: 'auditlog',
          name: 'AuditLog',
          component: () => import(/* webpackChunkName: "auditlog" */'../views/log/index.vue'),
          meta: { title: 'Audit Log' }
        },
        {
          path: 'client',
          name: 'ClientParam',
          component: () => import(/* webpackChunkName: "client-param" */'../views/clientparam/index.vue'),
          meta: { title: 'Client Param' }
        },
        {
          path: 'agent',
          name: 'Agent',
          component: () => import(/* webpackChunkName: "agent" */'../views/agent/index.vue'),
          meta: { title: 'Agent' }
        },
        {
          path: 'map',
          name: 'TopicUserMap',
          component: () => import(/* webpackChunkName: "map" */'../views/map/index.vue'),
          meta: { title: 'Map' }
        },
        {
          path: 'monitor',
          name: 'Monitor',
          component: () => import(/* webpackChunkName: "monitor" */'../views/monitor/index.vue'),
          meta: { title: 'Monitor', keepAlive: false }
        },
        {
          path: 'webhook',
          name: 'Webhook',
          component: () => import(/* webpackChunkName: "webhook" */'../views/webhook/index.vue'),
          meta: { title: 'Webhook' }
        },
        {
          path: 'topicalert',
          name: 'TopicAlert',
          component: () => import(/* webpackChunkName: "topicalert" */'../views/topicAlert/index.vue'),
          meta: { title: 'TopicAlert' }
        },
        {
          path: 'document',
          name: 'Document',
          component: () => import(/* webpackChunkName: "document" */'../views/document/index.vue'),
          meta: { title: 'Document' }
        },
        {
          path: 'clientMap',
          name: 'ClientMap',
          component: () => import(/* webpackChunkName: "client-map" */'../views/clientMap/index.vue'),
          meta: { title: 'Client Map' }
        },
        {
          path: 'monitorManage',
          name: 'MonitorManage',
          component: () => import(/* webpackChunkName: "monitor-manage" */'../views/monitorManagement/index.vue'),
          meta: { title: 'Monitor Management', reuseTab: 'AlarmRule' },
          children: [
            {
              path: 'notificationChannel',
              name: 'NotificationChannel',
              component: () => import(/* webpackChunkName: "monitor-manage-channel" */'../views/monitorManagement/channel.vue'),
              meta: { title: 'Monitor Manage', reuseTab: 'AlarmRule' }
            },
            {
              path: 'notificationRule',
              name: 'NotificationRule',
              component: () => import(/* webpackChunkName: "monitor-manage-notification-rule" */'../views/monitorManagement/notificationRule.vue'),
              meta: { title: 'Monitor Manage', reuseTab: 'AlarmRule' }
            },
            {
              path: 'routeRule',
              name: 'RouteRule',
              component: () => import(/* webpackChunkName: "monitor-manage-route-rule" */'../views/monitorManagement/routeRule.vue'),
              meta: { title: 'Monitor Manage', reuseTab: 'AlarmRule' }
            },
            {
              path: 'inhibitRule',
              name: 'InhibitRule',
              component: () => import(/* webpackChunkName: "monitor-manage-inhibit-rule" */'../views/monitorManagement/inhibitRule.vue'),
              meta: { title: 'Monitor Manage', reuseTab: 'AlarmRule' }
            },
            {
              path: 'silenceRule',
              name: 'SilenceRule',
              component: () => import(/* webpackChunkName: "monitor-manage-silence-rule" */'../views/monitorManagement/silenceRule.vue'),
              meta: { title: 'Monitor Manage', reuseTab: 'AlarmRule' }
            },
            {
              path: 'alarmRule',
              name: 'AlarmRule',
              component: () => import(/* webpackChunkName: "monitor-manage-alarm-rule" */'../views/monitorManagement/alarmRule.vue'),
              meta: { title: 'Monitor Manage', reuseTab: 'AlarmRule' }
            },
            {
              path: 'alarmRecord',
              name: 'AlarmRecord',
              component: () => import(/* webpackChunkName: "monitor-manage-alarm-record" */'../views/monitorManagement/alarmRecord.vue'),
              meta: { title: 'Monitor Manage', reuseTab: 'AlarmRule' }
            },
            {
              path: 'notificationRecord',
              name: 'NotificationRecord',
              component: () => import(/* webpackChunkName: "monitor-manage-notification record" */'../views/monitorManagement/notificationRecord.vue'),
              meta: { title: 'Monitor Manage', reuseTab: 'AlarmRule' }
            }
          ]
        },
        {
          path: 'monitorAlarm',
          name: 'MonitorAlarm',
          component: () => import(/* webpackChunkName: "monitor-manage-alarm-record" */'../views/monitorManagement/alarmRecord.vue'),
          meta: { title: 'Monitor Alarm' }
        },
        {
          path: 'smart',
          name: 'Smart',
          component: () => import(/* webpackChunkName: "smart-index" */'../views/smart/index.vue'),
          meta: { title: 'Smart' }
        },
        {
          path: 'smart/pool/:name/:id',
          name: 'ServiceRegion',
          component: () => import(/* webpackChunkName: "smart-pool" */'../views/smart/pool.vue'),
          meta: { title: 'Service Region', reuseTab: 'Smart' }
        },
        {
          path: 'smart/client/:name/:id',
          name: 'SmartClient',
          component: () => import(/* webpackChunkName: "smart-client" */'../views/smart/client.vue'),
          meta: { title: 'Client', reuseTab: 'Smart' }
        },
        {
          path: 'smart/:serviceName/:poolName/client/:serviceId/:poolId',
          name: 'ServiceRegionClient',
          component: () => import(/* webpackChunkName: "smart-service-region-client" */'../views/smart/poolClient.vue'),
          meta: { title: 'Service Region Client', reuseTab: 'Smart' }
        },
        {
          path: 'smart/:serviceName/:poolName/application/:serviceId/:poolId',
          name: 'SmartApplication',
          component: () => import(/* webpackChunkName: "smart-application" */'../views/smart/application.vue'),
          meta: { title: 'Application', reuseTab: 'Smart' }
        },
        {
          path: 'smart/result',
          name: 'SmartResult',
          component: () => import(/* webpackChunkName: "smart-result" */'../views/smart/result.vue'),
          meta: { title: 'Smart Result', reuseTab: 'Smart' }
        },
        {
          path: 'manage/cluster',
          name: 'KafkaCluster',
          component: () => import(/* webpackChunkName: "kafkacluster" */'../views/kafkaManage/cluster.vue'),
          meta: { title: 'Kafka Manage Cluster' }
        },
        {
          path: 'manage/describe/topic',
          name: 'Topic Describe',
          component: () => import(/* webpackChunkName: "KafkaDescribe" */'../views/kafkaManage/topicDescribe.vue'),
          meta: { title: 'Kafka Manage Topic Describe' }
        },
        {
          path: 'manage/describe/group',
          name: 'Group Describe',
          component: () => import(/* webpackChunkName: "KafkaDescribe" */'../views/kafkaManage/groupDescribe.vue'),
          meta: { title: 'Kafka Manage Group Describe' }
        },
        {
          path: 'manage/cluster/describe/:id',
          name: 'KafkaDescribe',
          component: () => import(/* webpackChunkName: "kafka-describe" */'../views/kafkaManage/describe.vue'),
          meta: { title: 'Kafka Manage Describe' },
          children: [
            {
              path: 'topic',
              name: 'ManageTopicDescribe',
              component: () => import(/* webpackChunkName: "manage-topic-describe" */'../views/kafkaManage/topicDescribe.vue'),
              meta: { title: 'Kafka Manage Topic Describe', reuseTab: 'ManageTopicDescribe' }
            },
            {
              path: 'group',
              name: 'ManageGroupDescribe',
              component: () => import(/* webpackChunkName: "manage-group-describe" */'../views/kafkaManage/groupDescribe.vue'),
              meta: { title: 'Kafka Manage Group Describe', reuseTab: 'ManageTopicDescribe' }
            }
          ]
        },
        {
          path: 'manage/dashboard',
          name: 'KafkaDashboardManage',
          component: () => import(/* webpackChunkName: "KafkaDashboardManage" */'../views/cubeMonitor/index.vue'),
          meta: { title: 'Kafka Manage Dashboard' }
        },
        {
          path: 'manage/dashboard/:id/card',
          name: 'KafkaDashboardManageCard',
          component: () => import(/* webpackChunkName: "KafkaDashboardManageCard" */'../views/cubeMonitor/card.vue'),
          meta: { title: 'Kafka Manage Dashboard Card', keepAlive: false }
        },
        {
          path: 'manage/generate/:channelId',
          name: 'GenerateDashboard',
          component: () => import(/* webpackChunkName: "GenerateDashboard" */'../views/cubeMonitor/generate.vue'),
          meta: { title: 'Kafka Manage Generate Dashboard', keepAlive: false }
        },
        {
          path: 'manage/alert',
          name: 'ManageAlert',
          component: () => import(/* webpackChunkName: "Alert" */'../views/manage/alert.vue'),
          meta: { title: 'Kafka Manage Alert' }
        },
        {
          path: 'manage/reassign',
          name: 'ManageReassign',
          component: () => import(/* webpackChunkName: "Reassign" */'../views/manage/reassign.vue'),
          meta: { title: 'Kafka Manage Reassign' }
        },
        {
          path: 'manage/webhook',
          name: 'ManageWebhook',
          component: () => import(/* webpackChunkName: "manage-webhook" */'../views/manage/webhook.vue'),
          meta: { title: 'Kafka Manage Webhook' }
        },
        {
          path: 'manage/cube',
          name: 'CubeMonitor',
          component: () => import(/* webpackChunkName: "CubeMonitor" */'../views/manage/cubeMonitor.vue'),
          meta: { title: 'Kafka Manage CubeMonitor' }
        },
        {
          path: 'manage/topictemplate',
          name: 'TopicTemplate',
          component: () => import(/* webpackChunkName: "TopicTemplate" */'../views/manage/topicTemplate/index.vue'),
          meta: { title: 'Topic Template' }
        },
        {
          path: 'permission',
          name: 'PermissionMenuStatement',
          redirect: '/dashboard/permission/menu',
          component: () => import(/* webpackChunkName: "permission-menu-statement" */'../views/statement/index.vue'),
          meta: { title: 'Permission Management' },
          children: [
            {
              path: 'menu',
              name: 'PermissionMenu',
              component: () => import(/* webpackChunkName: "permission-menu" */'../views/statement/menu.vue'),
              meta: { title: 'menu' }
            },
            {
              path: 'statement',
              name: 'PermissionStatement',
              component: () => import(/* webpackChunkName: "permission-statement" */'../views/statement/statement.vue'),
              meta: { title: 'statement', reuseTab: 'PermissionMenu' }
            }
          ]
        },
        {
          path: 'tags',
          name: 'Tags',
          component: () => import(/* webpackChunkName: "taga" */'../views/tags/index.vue'),
          meta: { title: 'Tags' }
        },
        {
          path: 'manage/acl',
          name: 'ACL',
          component: () => import('../views/manage/acl.vue'),
          meta: { title: 'Kafka Manage ACL' }
        },
        {
          path: 'manage/token',
          name: 'ManageToken',
          component: () => import('../views/manage/token.vue'),
          meta: { title: 'Kafka Manage Token' }
        },
        {
          path: 'manage/scram',
          name: 'Scram',
          component: () => import('../views/manage/scram.vue'),
          meta: { title: 'Kafka Manage Scram' }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */'../views/login/index.vue')
    },
    {
      path: '/asyncmq/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */'../views/login/index.vue')
    }
  ]
}
const originalPush = Router.prototype.push

Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  return originalPush.call(this, location).catch((err) => err)
}

const router = new Router(routerConfig)

function handleMultiTab (to, from, next) {
  if (to.name === 'login') {
    Vue.prototype.$MultiTabs.clear()
    return
  }
  if (to.meta.reuseTab && to.meta.reuseTab === to.name) {
    Vue.prototype.$MultiTabs.push({
      name: to.name,
      query: to.query,
      params: to.params,
      label: to.meta.label || to.query.label || to.meta.title
    })
  } else if (!to.meta.reuseTab) {
    Vue.prototype.$MultiTabs.push({
      name: to.name,
      query: to.query,
      params: to.params,
      label: to.meta.label || to.query.label || to.meta.title
    })
  }
}

router.beforeEach((to, from, next) => {
  handleMultiTab(to, from, next)
  next()
})

export default router
